import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type ClassificationWarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  isLoading?: boolean;
};

export const ClassificationWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  isLoading = false,
}: ClassificationWarningModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content useCustomOverlay>
        <StatusModal type="warning" title={title}>
          <p className="t-text-body-sm t-text-text-30 t-m-0">{description}</p>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Button onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            customType="primary"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
